import React, { createContext, FC, useContext } from "react";

interface Init {
  organizationId: string | null
  resetOrganizationId: () => void;
}

const defaultInit: Init = {
  organizationId: null,
  resetOrganizationId: () => {
  }
}

export const InitContext = createContext<Init>(defaultInit);

interface Props {
  organizationId: string | null;
  children: JSX.Element;
}


const InitProvider: FC<Props> = (props) => {
  const init = {
    organizationId: props.organizationId,
    resetOrganizationId: () => init.organizationId = null
  }
  return (
    <InitContext.Provider value={init}>
      {props.children}
    </InitContext.Provider>)
}
export default InitProvider;

export function useInit() {
  return useContext(InitContext);
}

